import React from "react";
import _ from "lodash";
import isEmail from "validator/lib/isEmail";
import { connect } from "react-redux";
import * as resActions from "../../modules/resources";
import PropTypes from "prop-types";
import { alertSuccess } from "../../utils/alerts";
import QboxmailApi from "../../qboxmailApi";
import withFormState from "Components/withFormState";
import Input from "Components/input/Input";
import Button from "Components/button/Button";
import PasswordGenerator from "Components/PasswordGenerator";
import { formatServerErrors } from "Utils/serverFormats";
import CustomerSelect from "Components/customerSelect/CustomerSelect";
import MultipleSelector from "Components/multipleSelector/MultipleSelector";
import TranslatedString from "Components/TranslatedString";
import { t } from "i18next";
import { Icon, warningFill } from "Icons/index";
import cx from "classnames";

const propTypes = {};

const ContextTypes = {
  router: PropTypes.object,
  isLoggedUserTrial: PropTypes.func,
  getLoggedUser: PropTypes.func,
  isLoggedUserAdmin: PropTypes.func,
};

const formInitialState = {
  max_domains: 5,
  max_email_accounts: 10,
  max_email_accounts_archive: 10,
  max_email_accounts_25gb: 10,
  max_email_accounts_50gb: 0,
  max_email_accounts_100gb: 0,
  firstname: "",
  lastname: "",
  company: "",
  password: "",
  password_confirmation: "",
  email_address: "",
  domain_codes: [],
  customer_code: undefined,
};

class ManagerNewScreen extends React.Component {
  constructor(props) {
    super(props);
    this.setCustomerCode = this.setCustomerCode.bind(this);
    this.fillPasswordFields = this.fillPasswordFields.bind(this);
    this.clearDomainsSelect = this.clearDomainsSelect.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.resetAndGoBack = this.resetAndGoBack.bind(this);
    this.state = {};
  }

  UNSAFE_componentWillMount() {
    if (!this.context.isLoggedUserAdmin()) {
      this.props.getAllDomainsWithoutManagers();
    }
  }

  componentDidMount() {
    this.firstInput.focus();
  }

  componentWillUnmount() {
    this.props.resetForm();
  }

  returnToList() {
    this.props.history.push(`/managers`);
  }

  validate(values) {
    let errors = {};
    const requiredFields = ["password", "password_confirmation", "firstname", "lastname"];
    for (let i = 0; i < requiredFields.length; i++) {
      if (!values[requiredFields[i]]) errors[requiredFields[i]] = "is required";
    }
    if (values.password.length < 8) errors.password = "is too short";
    if (values.password !== values.password_confirmation) {
      errors.password_confirmation = "is not the same";
    }

    if (!isEmail(values.email_address)) {
      errors.email_address = "is not valid";
    }
    return errors;
  }

  submitForm(e) {
    e.preventDefault();
    const { formData, setFormLoading, refreshManagers, unsetFormLoading, setFormErrors } = this.props;
    setFormLoading();

    const errors = this.validate(formData);

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      unsetFormLoading();
    } else {
      const api = new QboxmailApi({ useCookie: true });
      api
        .createManager(Object.assign(formData))
        .then(() => {
          refreshManagers();
          this.props.setFormErrors({});
          alertSuccess(t("alert.managerCreatedSuccess"));
          this.resetAndGoBack();
        })
        .catch((response) => {
          formatServerErrors(response).then((errors) => {
            this.props.setFormErrors(errors);
            this.props.unsetFormLoading();
          });
        });
    }
  }

  resetAndGoBack() {
    this.props.resetForm();
    this.returnToList();
  }

  clearDomainsSelect(values) {
    this.props.setFormFieldValue({ ...values, domain_codes: [] });
  }

  fillPasswordFields(generatedPassword) {
    this.props.setFormFieldValue({
      password: generatedPassword,
      password_confirmation: generatedPassword,
    });
  }

  setCustomerCode(v) {
    if (this.context.isLoggedUserAdmin()) {
      this.props.getAllDomainsWithoutManagers({
        customer_code: v.value,
      });
    }

    this.props.setFormFieldValue({ customer_code: v.value });
  }

  render() {
    const {
      formData,
      setFormFieldValue,
      formErrors,
      isFormLoading,
      areDomainsLoading,
      domainsWithoutManagers,
    } = this.props;

    return (
      <div className="formsPage">
        <div className={cx("sectionTitle", "titleFP")}>{t("managers.add.title.step1")}</div>

        <div className="wrapScrollFP">
          <div className="infoFP">
            <div className="sectionDesc">{t("managers.add.desc.step1")}</div>
            <Button className="btnDocsFP" docsKey="managers_add" color="docs" sizeSmall>
              button.docs
            </Button>
          </div>

          <form className="wrapFormsFP" method="post" onSubmit={this.submitForm}>
            <div className="formsFP">
              <Input
                className="inputFull2"
                label={t("input.label.firstName")}
                placeholder={t("input.placeholder.firstName")}
                name="firstname"
                onChange={setFormFieldValue}
                errors={formErrors.firstname}
                value={formData.firstname}
                ref={(el) => (this.firstInput = el)}
                required
              />
              <Input
                className="inputFull2"
                label={t("input.label.lastName")}
                placeholder={t("input.placeholder.lastName")}
                name="lastname"
                onChange={setFormFieldValue}
                errors={formErrors.lastname}
                value={formData.lastname}
                required
              />
              <Input
                className="inputFull2"
                label={t("input.label.company")}
                placeholder={t("input.placeholder.company")}
                name="company"
                onChange={setFormFieldValue}
                errors={formErrors.company}
                value={formData.company}
              />
              <Input
                className={cx("inputFull2", "inputAddMargin")}
                label={t("input.label.email")}
                placeholder={t("input.placeholder.email")}
                name="email_address"
                onChange={setFormFieldValue}
                errors={formErrors.email_address}
                value={formData.email_address}
                type="email"
                required
              />
              <Input
                className="inputFull2"
                label={t("input.label.password")}
                name="password"
                onChange={setFormFieldValue}
                errors={formErrors.password}
                value={formData.password}
                type="password"
                required
              />
              <Input
                className="inputFull2"
                label={t("input.label.passwordConfirm")}
                name="password_confirmation"
                onChange={setFormFieldValue}
                errors={formErrors.password_confirmation}
                value={formData.password_confirmation}
                type="password"
                required
              />
              <PasswordGenerator
                className={cx("inputFull2", "inputAddMargin")}
                onNewPassword={this.fillPasswordFields}
              />

              {this.context.isLoggedUserAdmin() && (
                <CustomerSelect
                  className={cx("inputFull2", "inputAddMargin")}
                  label={t("input.label.customer")}
                  value={formData.customer_code}
                  onChange={this.setCustomerCode}
                />
              )}

              {(!this.context.isLoggedUserAdmin() || (this.context.isLoggedUserAdmin() && formData.customer_code)) && (
                <>
                  <Input
                    label={t("input.label.maxDomainsAvailable")}
                    name="max_domains"
                    type="number"
                    onChange={setFormFieldValue}
                    errors={formErrors.max_domains}
                    value={formData.max_domains}
                    min={-1}
                    max={99999}
                    step="1"
                    required
                  />

                  <Input
                    label={t("input.label.maxAccountsAvailable8")}
                    name="max_email_accounts"
                    type="number"
                    onChange={setFormFieldValue}
                    errors={formErrors.max_email_accounts}
                    value={formData.max_email_accounts}
                    min={-1}
                    max={99999}
                    step="1"
                    required
                  />
                  <Input
                    label={t("input.label.maxAccountsAvailable25")}
                    name="max_email_accounts_25gb"
                    type="number"
                    onChange={setFormFieldValue}
                    errors={formErrors.max_email_accounts_25gb}
                    value={formData.max_email_accounts_25gb}
                    min={-1}
                    max={formData.max_email_accounts !== -1 ? formData.max_email_accounts : 9999999}
                    step="1"
                    required
                  />

                  <Input
                    label={t("input.label.maxAccountsAvailable50")}
                    name="max_email_accounts_50gb"
                    type="number"
                    onChange={setFormFieldValue}
                    errors={formErrors.max_email_accounts_50gb}
                    value={formData.max_email_accounts_50gb}
                    min={-1}
                    max={formData.max_email_accounts !== -1 ? formData.max_email_accounts : 9999999}
                    step="1"
                    required
                  />

                  <Input
                    label={t("input.label.maxAccountsAvailable100")}
                    name="max_email_accounts_100gb"
                    type="number"
                    onChange={setFormFieldValue}
                    errors={formErrors.max_email_accounts_100gb}
                    value={formData.max_email_accounts_100gb}
                    min={-1}
                    max={formData.max_email_accounts !== -1 ? formData.max_email_accounts : 9999999}
                    step="1"
                    required
                  />

                  <Input
                    className="inputAddMargin"
                    label={t("input.label.maxArchiveAvailable")}
                    name="max_email_accounts_archive"
                    type="number"
                    onChange={setFormFieldValue}
                    errors={formErrors.max_email_accounts_archive}
                    value={formData.max_email_accounts_archive}
                    min={-1}
                    max={formData.max_email_accounts !== -1 ? formData.max_email_accounts : 9999999}
                    step="1"
                    required
                  />
                </>
              )}

              {(!this.context.isLoggedUserAdmin() || (this.context.isLoggedUserAdmin() && formData.customer_code)) &&
                !areDomainsLoading && (
                  <MultipleSelector
                    className={cx("inputFull2", "inputAddMargin")}
                    label={<TranslatedString>input.label.domainsManager</TranslatedString>}
                    name="domain_codes"
                    options={_.map(domainsWithoutManagers, (v) => ({
                      value: v.code,
                      label: v.name,
                    }))}
                    firstPanelTitle={<TranslatedString>input.label.domainsAvailable</TranslatedString>}
                    secondPanelTitle={<TranslatedString>input.label.domainsSelected</TranslatedString>}
                    onChange={setFormFieldValue}
                  />
                )}
            </div>

            {formErrors.onForm && (
              <div className="warningMsgFP">
                <Icon className="iconWarningMsgFP" svg={warningFill} width="1rem" height="1rem" />
                <div className="textWarningMsgFP">{formErrors.onForm}</div>
              </div>
            )}

            <div className="footerFP">
              <Button color="text" onClick={this.resetAndGoBack}>
                button.cancel
              </Button>
              <Button color="green" type="submit" loading={isFormLoading}>
                button.create
              </Button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

//ManagerNewScreen.propTypes = propTypes;
ManagerNewScreen.contextTypes = ContextTypes;

const mapStateToProps = (state) => ({
  domainsWithoutManagers: resActions.getData("domainsNoManagers.data", state),
  areDomainsLoading: resActions.isResourceLoading("domainsNoManagers", state),
});

const mapDispatchToProps = (dispatch, props) => {
  return {
    getAllDomainsWithoutManagers: (params) => {
      dispatch(resActions.callApi("getAllDomainsWithoutManagers", "domainsNoManagers", params));
    },
    refreshManagers: (queryParams) => dispatch(resActions.callApi("refreshManagers", "managers", queryParams)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withFormState(ManagerNewScreen, formInitialState));
